import { useState } from 'react'

// Keeps track of a value from the first render of the component.
export function useFirstRenderValue<T>(valueOrSetter: T | (() => T)): T {
  return useState(valueOrSetter)[0]
}
